// @ts-nocheck
import React, { useState } from 'react';

/**
 * Bordered input with optional left icon, an inline label-row that can host
 * a "Forgot?" link, and an optional reveal-button for password fields.
 */
const Field = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  autoComplete,
  placeholder,
  icon: Icon,
  rightLink,
  reveal,
  error,
}) => {
  const [showing, setShowing] = useState(false);
  const inputType = reveal ? (showing ? 'text' : 'password') : type;

  return (
    <div className="mb-[18px]">
      <div className="flex items-baseline justify-between mb-2">
        <label
          htmlFor={name}
          className="text-[12.5px] font-medium text-mov-ink"
          style={{ letterSpacing: '0.005em' }}
        >
          {label}
        </label>
        {rightLink}
      </div>
      <div className={`input-wrap ${error ? 'has-error' : ''}`}>
        {Icon && (
          <span className="input-icon" aria-hidden="true">
            <Icon />
          </span>
        )}
        <input
          id={name}
          name={name}
          type={inputType}
          value={value}
          onChange={e => onChange(name, e.target.value)}
          autoComplete={autoComplete}
          placeholder={placeholder}
          style={Icon ? undefined : { paddingLeft: '14px' }}
        />
        {reveal && (
          <button
            type="button"
            onClick={() => setShowing(s => !s)}
            className="reveal-btn"
            aria-label={showing ? 'Hide password' : 'Show password'}
          >
            {showing ? 'Hide' : 'Show'}
          </button>
        )}
      </div>
    </div>
  );
};

export default Field;
